<template>
  <div v-if="rangeSet" class="review">
    <div class="review__title">{{modelReview.title}}</div>
    <div class="review__image" :style="{ backgroundImage: `url(${modelReview.imageLink})`, backgroundPosition: `0% ${modelReview.position}%`}"> </div>
    <div :class="{
      'review__text': true,
      'review__text--collapsed': isCollapsed}">
      <span class="review__text-copy" v-html="modelReview.copy"></span>
      <a v-if="!hideLink && modelReview.link" class="review__link" :href="modelReview.link" target="_blank">See the full review here</a>
    </div>
    <span
      @click="toggleExpand()"
      :class="{
        'review__expand': true,
        'review__expand--collapsed': isCollapsed}">{{this.expandText}}</span>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Provide, Vue, Watch
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ContentSourceType from '@/enums/ContentSourceType';
import IRange from '../../models/vehicle/interfaces/range.d';
import IContentSourceJsonModel from '../../models/interfaces/content-source-json-model.d';

const VehicleModule = namespace('vehicleModule');
const bmwCKReviewData = require('../../bmw-review/reviews.json');

@Component
export default class ReviewComponent extends Vue {
  @VehicleModule.Getter public currentRange!: IRange;

  @Prop({ default: false })
  public hideLink!: boolean;

  @Prop({ default: ContentSourceType.CarKeys })
  public contentSource!: number;

  private isCollapsed: boolean = true;

  public data: IContentSourceJsonModel[] = [];

  public modelReview: IContentSourceJsonModel | null = null;

  public get expandText(): string {
    return this.isCollapsed ? 'Read more' : 'Read less';
  }

  public get rangeSet(): boolean {
    if (this.currentRange !== null && this.modelReview !== null && this.modelReview !== undefined) {
      return true;
    }

    return false;
  }

  public get getRangeId(): number {
    if (this.currentRange === null) {
      return 0;
    }

    return this.currentRange.rangeId;
  }

  @Watch('getRangeId')
  public loadDataByRangeId() {
    this.modelReview = this.data[this.currentRange.rangeId];
  }

  public loadData() {
    this.data = bmwCKReviewData.reduce((acc, item: IContentSourceJsonModel) => {
      if (item.publisherId === this.contentSource.toString()) {
        acc[item.rangeId] = item;
      }

      return acc;
    }, {});
  }

  public toggleExpand() {
    this.isCollapsed = !this.isCollapsed;
  }

  public created() {
    this.loadData();
  }
}
</script>
